import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useLanguage } from '../i18n/LanguageContext';

const HeroSection = styled.div`
  position: relative;
  height: 60vh;
  min-height: 400px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)), url(${props => props.bgImage});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
  
  @media (max-width: 768px) {
    background-attachment: scroll;
    min-height: 350px;
    height: 50vh;
  }
`;

const HeroContent = styled.div`
  text-align: center;
  color: white;
  z-index: 2;
  padding: 0 20px;
  
  h1 {
    font-size: 4rem;
    font-weight: 700;
    margin-bottom: 20px;
    letter-spacing: -1px;
    text-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
    color: #ffffff;
    
    @media (max-width: 768px) {
      font-size: 2.5rem;
      margin-bottom: 15px;
    }
  }
  
  p {
    font-size: 1.4rem;
    max-width: 800px;
    margin: 0 auto;
    font-weight: 400;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    color: #f8f9fa;
    
    @media (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 60px auto 60px;
  padding: 0 20px;
`;

const SubsidiariesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
`;

const SubCard = styled(Link)`
  display: block;
  padding: 30px;
  background: #ffffff;
  border-radius: 16px;
  text-decoration: none;
  color: inherit;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }
`;

const SubIcon = styled.div`
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #2B4B8C, #4B6CB7);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  margin-bottom: 20px;
`;

const SubName = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c2c2c;
  margin-bottom: 12px;
`;

const SubDescription = styled.p`
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 16px;
`;

const SubStatus = styled.span`
  display: inline-block;
  padding: 6px 12px;
  background: ${props => props.active ? '#dcfce7' : '#fef3c7'};
  color: ${props => props.active ? '#166534' : '#92400e'};
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
`;

const Subsidiaries = () => {
  const { t } = useLanguage();
  return (
    <>
      <HeroSection bgImage="/images/subsidiaries-hero.jpg">
        <HeroContent>
          <h1>{t('subsidiaries.heroTitle')}</h1>
          <p>{t('subsidiaries.heroDesc')}</p>
        </HeroContent>
      </HeroSection>
      <Container>
        <SubsidiariesGrid>
          <SubCard to="/istirakler/rakka-alci">
            <SubIcon>🚧</SubIcon>
            <SubName>{t('f.rakkaAlciT')}</SubName>
            <SubDescription>{t('f.rakkaAlciS')}</SubDescription>
            <SubStatus>{t('factories.inProgress', 'Devam Ediyor')}</SubStatus>
          </SubCard>

          <SubCard to="/istirakler/urfa-kalker">
            <SubIcon>⛏️</SubIcon>
            <SubName>{t('f.urfaKalkerT')}</SubName>
            <SubDescription>{t('f.urfaKalkerS')}</SubDescription>
            <SubStatus active>{t('factories.active')}</SubStatus>
          </SubCard>

          <SubCard to="/istirakler/lojistik">
            <SubIcon>🚚</SubIcon>
            <SubName>{t('f.lojistikT')}</SubName>
            <SubDescription>{t('f.lojistikS')}</SubDescription>
            <SubStatus active>{t('factories.active')}</SubStatus>
          </SubCard>
        </SubsidiariesGrid>
      </Container>
    </>
  );
};

export default Subsidiaries;
